<template>
  <div class="section">
    <div class="perfect">
      <div class="max-width">
        <div class="perfect__grid">
          <div class="perfect__pic fadeIn">
            <img loading="lazy" srcset="@/assets/imgs/perfect-img.webp 1x, @/assets/imgs/perfect-img@2x.webp 2x" src="@/assets/imgs/perfect-img.webp">
          </div>

          <div class="perfect__about fadeIn">
            <div class="section__head section__head_middle">
              <div class="section__subheading section__subheading_themes fadeIn">Every Pixel</div>
              <h2 class="section__title">Designed to be&nbsp;perfect</h2>
              <div class="section__text">Themes that look flawless on every screen — mobile-optimized, made to sell.</div>
            </div>
          </div>
        </div>
      </div>

      <div class="perfect__line">
        <div class="perfect__slider">
          <div class="scroll-banner">
            <div class="scroll-banner__track">
              <div class="perfect__item">Shopify Partners</div>
              <div class="perfect__item">Shopify Partners</div>
              <div class="perfect__item">Shopify Partners</div>
              <div class="perfect__item">Shopify Partners</div>
              <div class="perfect__item">Shopify Partners</div>
              <div class="perfect__item">Shopify Partners</div>
              <div class="perfect__item">Shopify Partners</div>
            </div>
            <div class="scroll-banner__track" aria-hidden="true">
              <div class="perfect__item">Shopify Partners</div>
              <div class="perfect__item">Shopify Partners</div>
              <div class="perfect__item">Shopify Partners</div>
              <div class="perfect__item">Shopify Partners</div>
              <div class="perfect__item">Shopify Partners</div>
              <div class="perfect__item">Shopify Partners</div>
              <div class="perfect__item">Shopify Partners</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss">
  .perfect {
    background:var(--color-gray-light);
    position:relative;
    margin-bottom:2rem;

    &__grid {
      padding:5rem 0 10rem;
      display:flex;
      align-items:center;
      gap:3rem;

      @include md {
        padding-bottom:5rem;
        flex-direction:column;
      }
    }

    &__pic {
      flex:auto;

      img {
        border-radius:100vw;
      }

      @include md {
        max-width:60%;
        margin:0 auto;
      }

      @include xs {
        max-width:100%;
      }
    }

    &__about {
      flex:none;
      width:50%;

      @include md {
        width:100%;
      }

      .section__head {
        margin:0 auto;
      }

      @include lg {
        .section__title {
          font-size:4rem;
        }
      }

      @include md {
        .section__text {
          font-size:1rem;
          max-width:450px;
        }
      }

      @include xs {
        .section__title {
          font-size:2.5rem;
        }
      }
    }

    &__line {
      height:5rem;
      background:var(--color-main);
      position:absolute;
      bottom:-2rem;
      left:-2rem;
      display:flex;
      align-items:center;
      width:calc(100% + 4rem);
      transform:rotate(-2deg);
      z-index:2;

      @include md {
        height:3.5rem;
      }
    }

    &__item {
      display:flex;
      align-items:center;
      gap:1.875rem;

      &:before {
        content:'';
        width:12px;
        height:12px;
        background:#fff;
        border-radius:50%;
        display:block;

        @include md {
          width:8px;
          height:8px;
        }
      }
    }

    &__slider {
      .scroll-banner {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: auto;
        white-space: nowrap;
        font-size: 51px;
        line-height: 1;
        letter-spacing: -0.02em;
        font-family:var(--font-secondary);
        color:#fff;
        display:flex;
        align-items:center;
        gap:1.875rem;
        --scroll-speed:20s;

        @include md {
          font-size:2rem;
        }

        &__track {
          display: flex;
          animation: scroll-x linear infinite;
          animation-duration: var(--scroll-speed);
          gap:1.875rem;
        }
      }

      @keyframes scroll-x {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(calc(-50% - 1.875rem));
        }
      }
    }
  }
</style>
